import Container from '../../ui-kit/components/wrappers/Container'
import UserNotification from '../molecules/notifications/UserNotification'
import ReactionNotification from '../molecules/notifications/ReactionNotification'
import InteractionNotification from '../molecules/notifications/InteractionNotification'
import {AT_ICON} from '../../ui-kit/helpers/icons/at'
import {COMMENT_ICON} from '../../ui-kit/helpers/icons/comment'
import {DIALOG_ICON} from '../../ui-kit/helpers/icons/dialog'

const NotificationPanel = () => {
  return (
    <Container className="notifications-panel">
      <header className="header">
        <h3>Notificaciones</h3>
        <button className="see-all-button">Marcar como leídas</button>
      </header>
      <div className="notification-list">
        <UserNotification unread />
        <UserNotification />
        <UserNotification />
        <InteractionNotification
          className="mention"
          icon={AT_ICON}
          caption="te ha mencionado en un comentario."
        />
        <InteractionNotification
          icon={COMMENT_ICON}
          caption="ha comentado tu publicación."
        />
        <InteractionNotification
          icon={COMMENT_ICON}
          caption="ha comentado tu publicación."
        />
        <ReactionNotification />
        <UserNotification unread />
        <InteractionNotification
          icon={DIALOG_ICON}
          caption="ha respondido a tu comentario."
        />
      </div>
    </Container>
  )
}

export default NotificationPanel
